import { Component, OnInit, ViewChild } from '@angular/core';
import { User } from '../_models/user';
import { ActivatedRoute, Router } from '@angular/router';
import { saveAs } from 'file-saver';
import { Title, Meta } from '@angular/platform-browser';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthenticationService } from '../authentication.service';
import { DamserviceService } from "../dam/damservice.service";
import { UploadFilesService } from 'src/app/services/upload-files.service';
import { PdfViewerComponent } from 'ng2-pdf-viewer';
import { AuthService } from "angularx-social-login";
import { OrganisationService } from "../create-organisation/organisation.service";

@Component({
  selector: 'app-share',
  templateUrl: './share.component.html',
  styleUrls: ['./share.component.css']
})
export class ShareComponent implements OnInit {

  constructor(
    private router: Router,
    private activateRoute: ActivatedRoute,
    private modalService: NgbModal,
    private authenticationService: AuthenticationService,
    private authService: AuthService,
    private uploadService: UploadFilesService,
    private damService: DamserviceService,
    private titleService: Title,
    private metaTagService: Meta,
    private organisationService: OrganisationService,
  ) { }

  currentUser: User;

  workspaceName: string;
  imageHeading: string;
  addTagText: string;
  boardHeading: string;
  boardname: string;
  workspace_token: string;
  user_from: string;
  fileText: string;

  userPic: any;
  workspaceId: any;
  boardId: any;
  currentIllus: any;
  currentIllusPosition: any;
  totalIllusCount: any;
  count: number = 0;
  returnUrl: any;

  fileInfos: [];
  addedTagList: Array<{tags: string}> = [];
  imagesIdList: Array<{id: any, title: string}> = [];
  imagesIds: Array<{id: any}> = [];
  imagesExtension: [];

  sendSuccessfulErrorMessage: any;
  successfullMessage: any;

  imageSelected:boolean = false;
  downloadDelete:boolean = false;
  mobileView: boolean = false;
  hideDialogSection: boolean = true;
  sendSuccessful: boolean = false;
  sendSuccessfulErrorMsg: boolean = false;
  showTopRightLoader: boolean = false;
  showShareDownloadLoader: boolean = false;
  showDownloadButton: boolean = false;

  mainSection: boolean = false;
  noDataSection: boolean = false;

  showErrorMessage: any;
  downloadImagesStyle = "none";

  totalSpaceAllowed: any;
  consumedSpaceAllowed: any;
  totalSpaceAllowedProgress: any;
  totalUsers: any;
  planId: any;
  planName: String;
  ownerEmail: String;
  ownerName: String;

  changeColor = [false, false, false];
  public selectedIndex;


  width: any;
  height: any;

  @ViewChild('imgMainModal') imgMainModal;

  ngOnInit(): void {
    this.metaTagService.addTags([
      { name: 'description', content: 'Crafttor Workspace provides you with number of boards you created and upload images to your boards keeping it secure and smooth to access images anytime.'},
      { name: 'keywords', content: 'boards, board, workspace, upload free illustrations, upload clean pixel illustrations, upload premium illustration, ' },
      { name: 'robots', content: 'index, follow' },
      { name: 'author', content: 'Crafttor' },
      { name: 'viewport', content: 'width=device-width, initial-scale=1' },
      { charset: 'UTF-8' }
    ]);

    this.authenticationService.currentUser.subscribe(x => { this.currentUser = x });
    if (window.screen.width <= 991) { // 768px portrait
      this.mobileView = true;
    }else{
      this.mobileView = false;
    }

    this.activateRoute.queryParams.subscribe(params => {
      this.returnUrl = params['returnUrl'];
      this.user_from = params['from'];
      this.workspace_token = params['token'];
      this.getAssetsList(this.workspace_token);
    });

    this.getUserPic();
  }

  getUserPic() {
    this.damService.getUserPic().subscribe((data: any) => {
      this.userPic = data.user_pic;
    });
  }

  openLoginScreen() {
    this.router.navigate(['/login']);
  }

  imageExtensionApi(){
    this.damService.imagesExtension(this.workspaceId, this.boardId).subscribe((data: any) => {
      this.imagesExtension = data['image_formats'];
    });
  }

  downloadAllImages (fileData: any) {
    for(let imges of fileData) {
      this.imagesIds.push(imges.id)
    }
    this.showShareDownloadLoader = true;
    this.damService.downloadSharedZipFile(this.workspaceId, this.boardId, this.imagesIds).subscribe((data: any) => {
        saveAs(data)
        this.showShareDownloadLoader = false;
        this.imagesIdList = [];
        this.imagesIds = [];
        this.imageSelected = false;
        this.downloadDelete = false;
        this.count = 0;
        this.closeDownloadImagesStyleBoard();
     });
  }

  closeDownloadImagesStyleBoard() {
   this.downloadImagesStyle = "none";
  }

  downloadSingleImage(imgId: any, imgTitle: string){
    this.damService.downloadSharedImages(this.workspaceId, this.boardId, imgId).subscribe((data: any) => {
        saveAs(data, imgTitle)
        this.imagesIdList = [];
        this.imagesIds = [];
        this.imageSelected = false;
        this.downloadDelete = false;
        this.count = 0;
     });
  }

  downloadMultipleImage(){
    if(this.count <= 1){
      for(let ids of this.imagesIdList){
         this.damService.downloadSharedImages(this.workspaceId, this.boardId, ids.id).subscribe((data: any) => {
             saveAs(data, ids.title)
             this.imagesIdList = [];
             this.imagesIds = [];
             this.imageSelected = false;
             this.downloadDelete = false;
             this.count = 0;
          });
      }
    }else{
      this.downloadZipFile();
    }
  }

  downloadZipFile(){
    for(let ids of this.imagesIdList){
      this.imagesIds.push(ids.id)
    }
    this.damService.downloadSharedZipFile(this.workspaceId, this.boardId, this.imagesIds).subscribe((data: any) => {
        saveAs(data)
        this.imagesIdList = [];
        this.imagesIds = [];
        this.imageSelected = false;
        this.downloadDelete = false;
        this.count = 0;
     });
  }

  openImgDialog(modal, imgName: string, imgPosition: any){
    this.addTagText = '';
    this.imageHeading = imgName;
    this.currentIllusPosition = imgPosition;
    this.imgMainModal = this.modalService.open(modal, { centered: true, windowClass: 'svg-modal ' });
  }

  getAssetsList(token: any){
    this.showTopRightLoader = true;
    this.addedTagList = [];
    this.uploadService.getSharedAssetsFiles(token).subscribe((data: any) => {
      this.mainSection = true;
      this.noDataSection = false;
      this.showTopRightLoader = false;
      this.fileInfos = data['results'];
      this.boardname = data['results'][0].board_title;
      this.boardId = data['results'][0].board;
      this.workspaceName = data['results'][0].workspace_title;
      this.workspaceId = data['results'][0].workspace_id;
      this.totalIllusCount = data['results'].length;
      this.titleService.setTitle(this.boardname + " | " + this.workspaceName + " | Workspace | Crafttor");
      for(let allowDownloads of data['results']) {
        if(allowDownloads.allow_downloads != false) {
          this.showDownloadButton = true;
        }
      }
      this.ownerListApi();
    },
    (error) => {
      if(error.status == 403 || error.status == 403){
        this.showTopRightLoader = false;
        this.mainSection = false;
        this.noDataSection = true;
        this.showErrorMessage = error.error.message;
      } else {
        this.showTopRightLoader = false;
        this.mainSection = false;
        this.noDataSection = true;
        this.showErrorMessage = error.error.message;
      }
    });
  }

  ownerListApi(){
    this.damService.getOwnerList(this.workspaceId).subscribe((data: any) => {
      this.ownerEmail = data.email;
      this.planName = data.plan_title;
      this.ownerName = data.first_name + " " + data.last_name;
      this.totalSpaceAllowed = data.allowed_dam_space_kb/1000000;
      this.consumedSpaceAllowed = data.current_dam_space/1000;
      this.totalSpaceAllowedProgress = data.allowed_dam_space_kb/1000;
      this.totalUsers = data.allowed_seats;
      this.planId = data.plan_id;
    });
  }

  nextImage(currentIllusPos: any) {
    this.addedTagList = [];
    if(currentIllusPos <= this.fileInfos.length-2) {
      for(var i = 0 ; i < this.fileInfos.length ; i++) {
        this.currentIllus = this.fileInfos[currentIllusPos+1];
        this.imageHeading = this.currentIllus.title;
      }
      this.currentIllusPosition = currentIllusPos+1;
    } else {
      //
    }
  }

  previousImage(currentIllusPos: any) {
    this.addedTagList = [];
    if(this.currentIllusPosition == 0) {
      //
    } else {
      for(var i = 0 ; i < this.fileInfos.length ; i++) {
        this.currentIllus = this.fileInfos[currentIllusPos-1];
        this.imageHeading = this.currentIllus.title;
      }
      this.currentIllusPosition = currentIllusPos-1;
    }
  }

  hideDialogClick(){
    if(this.hideDialogSection){
      this.hideDialogSection = false;
    }else{
      this.hideDialogSection = true;
    }
  }

  changeColors(i){
      this.selectedIndex = i;
  }

  showDownloadDeleteButtons(ivalue: any, i: any, imageId: any, titles: string){
    this.downloadDelete = true;
    this.imageSelected = true;
    this.sendSuccessful = false;
    if(ivalue == false){
      this.count--;
      if(this.count < 1){
        this.count = 0;
        this.imageSelected = false;
        this.downloadDelete = false;
        this.imagesIdList = [];
        this.imagesIds = [];
        this.changeColor = [];
      }
      if(this.count <= 1){
        this.fileText = 'file';
      }else{
        this.fileText = 'files';
      }
      this.imagesIdList.splice(i, 1);
    }else{
      this.count++;
      if(this.count <= 1){
        this.fileText = 'file';
      }else{
        this.fileText = 'files';
      }
      this.imagesIds.push(imageId);
      this.imagesIdList.push({id: imageId, title: titles});
    }
  }

  cancelImageSelection(){
    this.count = 0;
    this.imageSelected = false;
    this.downloadDelete = false;
    this.imagesIdList = [];
    this.imagesIds = [];
    this.changeColor = [];
  }

  @ViewChild(PdfViewerComponent, {static: false})
  private pdfComponent: PdfViewerComponent;
  pageRendered() {
    this.pdfComponent.pdfViewer.currentScaleValue = 'page-fit';
  }

  goToMarketplace() {
    window.open("https://crafttor.com/marketplace", "_blank");
  }

  logOut(): void {
    this.authenticationService.logout();
    this.authService.signOut();
    this.router.navigate(['/home']);
  }

  hideSuccesfullFunctionErrorDelete(){
    setTimeout(() => {
      this.sendSuccessfulErrorMsg = false;
    }, 5000);
  }

  goProClick() {
    this.router.navigate(['/dam/subscription']);
  }
}
